import 'bootstrap/dist/css/bootstrap.css'
import 'font-awesome/css/font-awesome.min.css'

import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import { ErrorModalProvider, GlobalStyle, SpinnerProvider, theme } from '@aserto/console-common'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import App from './App'
import reportWebVitals from './reportWebVitals'
import ActiveConfigurationProvider from './services/ActiveConfiguration'
import AuthProvider from './services/AuthProvider'
import CachePreloader from './services/CachePreloader'
import ConfigProvider from './services/ConfigProvider'
import ConsoleCommonProvider from './services/ConsoleCommonProvider'
import CustomQueryClientProvider from './services/CustomQueryClientProvider'
import OfflineBanner from './services/OfflineBanner'
import SmallScreenErrorModal from './services/SmallScreenErrorModal'

const queryClient = new QueryClient()
const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
  <React.StrictMode>
    <SmallScreenErrorModal />

    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <SpinnerProvider>
            <OfflineBanner />
            <ErrorModalProvider>
              <CustomQueryClientProvider>
                <CachePreloader>
                  <CachePreloader block>
                    <ConfigProvider>
                      <AuthProvider>
                        <ActiveConfigurationProvider>
                          <ConsoleCommonProvider>
                            <App />
                          </ConsoleCommonProvider>
                        </ActiveConfigurationProvider>
                      </AuthProvider>
                    </ConfigProvider>
                  </CachePreloader>
                </CachePreloader>
              </CustomQueryClientProvider>
            </ErrorModalProvider>
          </SpinnerProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
)
reportWebVitals()
